import React, { useEffect, useMemo, useState } from 'react';
import { fetchFeatureAccessOverview } from '../../services/api/adminFeatureAccessOverview';
import FeatureAccessOverview from '../../components/admin/FeatureAccessOverview';
import WorkspaceOverrideDrawer from '../../components/admin/WorkspaceOverrideDrawer';
import GrantOverrideModal from '../../components/admin/GrantOverrideModal';

const AdminFeatureAccess = () => {
  const [payload, setPayload] = useState({ plans: [], unplanned_workspaces: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');
  const [drawerWorkspace, setDrawerWorkspace] = useState(null);
  const [grantOpen, setGrantOpen] = useState(false);

  const load = async () => {
    try {
      setLoading(true);
      const res = await fetchFeatureAccessOverview();
      setPayload(res.data || { plans: [], unplanned_workspaces: [] });
    } catch (e) {
      setError(e?.response?.data?.error || e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const allWorkspaces = useMemo(() => {
    const out = [];
    (payload.plans || []).forEach((p) => (p.workspaces || []).forEach((w) => out.push(w)));
    (payload.unplanned_workspaces || []).forEach((w) => out.push(w));
    return out.sort((a, b) => a.name.localeCompare(b.name));
  }, [payload]);

  return (
    <div>
      <h1 className="text-2xl font-bold text-foreground mb-1">Feature Access</h1>
      <p className="text-sm text-muted-foreground mb-6">
        Plan defines what each workspace gets. Use overrides for exceptions.
      </p>

      {error && <div className="mb-4 p-3 bg-red-50 text-red-700 text-sm rounded-lg">{error}</div>}
      {loading ? (
        <div className="text-sm text-muted-foreground">Loading...</div>
      ) : (
        <FeatureAccessOverview
          payload={payload}
          search={search}
          onSearchChange={setSearch}
          onWorkspaceClick={(w) => setDrawerWorkspace(w)}
          onGrantClick={() => setGrantOpen(true)}
        />
      )}

      <WorkspaceOverrideDrawer
        open={!!drawerWorkspace}
        workspace={drawerWorkspace}
        onClose={() => setDrawerWorkspace(null)}
        onSaved={load}
      />
      <GrantOverrideModal
        open={grantOpen}
        workspaces={allWorkspaces}
        onClose={() => setGrantOpen(false)}
        onGranted={load}
      />
    </div>
  );
};

export default AdminFeatureAccess;
